import { item } from "../../../utils/animations"
import { motion } from "framer-motion";
import styles from './SolutionCard.module.css';

export type SolutionCardProps = {
    title: string;
    description: string;
    color: string;
}

export const SolutionCard = ({title, description, color}: SolutionCardProps) => {
    return (
        <motion.div
            className={styles.card}
            style={{
                backgroundColor: color
            }}
            variants={item}
        >
            <h2 className={styles.title}>{title}</h2>
            <p className={styles.description}>{description}</p>
        </motion.div>
    )
}